export function validateJsonNoDuplicateKeys(jsonStr: string) {
  const stack = []
  const keysStack = []

  // Перебираем токены вручную
  const tokenizer =
    /"(\\u[a-fA-F0-9]{4}|\\[^u]|[^\\"])*"\s*:|\{|\}|\[|\]|,|"(\\u[a-fA-F0-9]{4}|\\[^u]|[^\\"])*"|true|false|null|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g
  let match
  let lastKey = null

  while ((match = tokenizer.exec(jsonStr)) !== null) {
    const token = match[0]

    if (token === '{') {
      stack.push('{')
      keysStack.push(new Set())
    } else if (token === '}') {
      stack.pop()
      keysStack.pop()
    } else if (token.endsWith(':')) {
      const key = JSON.parse(token.slice(0, -1)) // безопасно парсим ключ
      const currentSet = keysStack[keysStack.length - 1]
      if (currentSet.has(key)) {
        throw new Error(`Duplicate key detected: "${key}"`)
      } else {
        currentSet.add(key)
      }
      lastKey = key
    }
  }

  // если всё ок, теперь можно распарсить как обычно
  return JSON.parse(jsonStr)
}
